/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_DISCOUNT = gql`
  query GetAllDiscounts($filter: DiscountFilterInput, $options: GetManyOptions) {
  getAllDiscounts(filter: $filter, options: $options) {
    content {
      _id
      name
      discountType
      img
      value
      startDate
      endDate
      usageLimit
      usedCount
      presentation {
        name
        id
      }
      section {
        id
        name
      }
      sectionOptType {
        name
        id
      }
      status
    }
    count
    skip
    limit
  }
}
`;
